function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/ContentApp.js
import PropTypes16 from "prop-types";
import React19 from "react";
import { Provider } from "react-redux";
import { setHeader } from "redux-json-api";

// src/actions/contentActionCreators.js
var contentActionCreators_exports = {};
__export(contentActionCreators_exports, {
  loadContentGroupItems: function loadContentGroupItems() {
    return _loadContentGroupItems;
  },
  loadProgress: function loadProgress() {
    return _loadProgress;
  },
  logTime: function logTime() {
    return _logTime;
  },
  pollProgress: function pollProgress() {
    return _pollProgress;
  },
  retakeEvaluation: function retakeEvaluation() {
    return _retakeEvaluation;
  },
  retryEvaluationWebhooks: function retryEvaluationWebhooks() {
    return _retryEvaluationWebhooks;
  },
  saveProgress: function saveProgress() {
    return _saveProgress;
  },
  signPolicy: function signPolicy() {
    return _signPolicy;
  }
});
import { readEntity } from "@everfi/reactifi/dist/es/actions/apiActions";
import { readLocal } from "@everfi/reactifi/dist/es/actions/coreApiActions";
import { pollUrl } from "@everfi/reactifi/dist/es/actions/downloadActions";
import { PathHelper } from "@everfi/reactifi/dist/es/utils/UrlUtil";
import { loadExternalData } from "@everfi/reactifi/dist/es/utils/ApiUtil";
import { displayErrorMessage } from "@everfi/reactifi/dist/es/actions/messagesActions";
var PROGRESS_POLL_INTERVAL = 1e3;
var PROGRESS_POLL_MAX_TIME = 6e4;
var MIME_JSON = "application/json";
var _loadProgress = function _loadProgress(progressId, contentServiceUrl, token) {
  return function (dispatch) {
    return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var url, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = "".concat(PathHelper.ensureEndSlash(contentServiceUrl), "api/v1/progress/").concat(progressId, ".json?response_set_tokens=true&include=content.content_config");
            _context.next = 3;
            return loadExternalData(url, token, false);
          case 3:
            data = _context.sent;
            dispatch(readLocal(data));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
};
var _loadContentGroupItems = function _loadContentGroupItems(contentGroupId) {
  return readEntity("content_group_items", "content.content_config", {
    content_group_id: contentGroupId
  });
};
var _saveProgress = function _saveProgress(progressId, type, contentServiceUrl, token) {
  return function () {
    var url = "".concat(contentServiceUrl, "/progress/").concat(progressId, "/").concat(type);
    fetch(url, {
      method: "POST",
      headers: {
        Accept: MIME_JSON,
        "Content-Type": MIME_JSON,
        Cache: "no-cache",
        Authorization: "Bearer ".concat(token)
      },
      body: JSON.stringify({
        data: {
          type: type,
          attributes: {}
        }
      })
    });
  };
};
var _retakeEvaluation = function _retakeEvaluation(progressId, evaluationSlug, contentServiceUrl, token) {
  var success = false;
  return function (dispatch) {
    return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", pollUrl({
              interval: PROGRESS_POLL_INTERVAL,
              max: PROGRESS_POLL_MAX_TIME,
              getData: function getData() {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                  var url, res;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        url = "".concat(PathHelper.ensureEndSlash(contentServiceUrl), "api/v1/progress/").concat(progressId, "/response_sets/").concat(evaluationSlug, "/retake");
                        _context2.next = 3;
                        return fetch(url, {
                          method: "PUT",
                          headers: {
                            Accept: MIME_JSON,
                            "Content-Type": MIME_JSON,
                            Cache: "no-cache",
                            Authorization: "Bearer ".concat(token)
                          }
                        });
                      case 3:
                        res = _context2.sent;
                        success = res.status === 200;
                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
              },
              checkComplete: function checkComplete() {
                return !!success;
              },
              onFinish: function onFinish() {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return dispatch(_loadProgress(progressId, contentServiceUrl, token));
                      case 2:
                        return _context3.abrupt("return", _context3.sent);
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
              },
              onTimeout: function onTimeout() {
                return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return dispatch(_loadProgress(progressId, contentServiceUrl, token));
                      case 2:
                        return _context4.abrupt("return", _context4.sent);
                      case 3:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
              }
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
  };
};
var _retryEvaluationWebhooks = function _retryEvaluationWebhooks(progressId, responseSetId, evalufiUrl, token, contentServiceUrl, csToken) {
  return function (dispatch) {
    return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var url;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            url = "".concat(evalufiUrl, "/response_sets/").concat(responseSetId, "/retry_webhooks");
            _context6.next = 3;
            return fetch(url, {
              method: "POST",
              headers: {
                Accept: MIME_JSON,
                "Content-Type": MIME_JSON,
                Cache: "no-cache",
                Authorization: "Bearer ".concat(token)
              }
            });
          case 3:
            _context6.next = 5;
            return dispatch(_loadProgress(progressId, contentServiceUrl, csToken));
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
  };
};
var _logTime = function _logTime(progressId, contentId, intervalSeconds, contentServiceUrl, token) {
  return function () {
    var url = "".concat(PathHelper.ensureEndSlash(contentServiceUrl), "api/v1/progress/").concat(progressId, "/time_log");
    fetch(url, {
      method: "POST",
      headers: {
        Accept: MIME_JSON,
        "Content-Type": MIME_JSON,
        Cache: "no-cache",
        Authorization: "Bearer ".concat(token)
      },
      body: JSON.stringify({
        data: {
          id: progressId,
          type: "progress",
          attributes: {
            type: "platform",
            content_id: contentId,
            duration: "PT".concat(intervalSeconds, "S")
          }
        }
      })
    });
  };
};
var _pollProgress = function _pollProgress(getData, checkComplete, onFinish, onTimeout) {
  return function () {
    return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            pollUrl({
              interval: PROGRESS_POLL_INTERVAL,
              max: PROGRESS_POLL_MAX_TIME,
              getData: getData,
              checkComplete: checkComplete,
              onFinish: onFinish,
              onTimeout: onTimeout
            });
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
  };
};
var _signPolicy = function _signPolicy(contentServiceUrl, token, policyId, progressId) {
  return function (dispatch) {
    return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return fetch("".concat(PathHelper.ensureEndSlash(contentServiceUrl), "api/v1/progress/").concat(progressId, "/policy_signatures"), {
              method: "POST",
              headers: {
                Accept: MIME_JSON,
                "Content-Type": MIME_JSON,
                Cache: "no-cache",
                Authorization: "Bearer ".concat(token)
              },
              body: JSON.stringify({
                data: {
                  type: "policy_signature",
                  attributes: {
                    policy_id: policyId,
                    resource_type: "PolicyResource"
                  }
                }
              })
            })["catch"](function (err) {
              return dispatch(displayErrorMessage(err));
            });
          case 2:
            return _context8.abrupt("return", _context8.sent);
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
  };
};

// src/containers/ContentContainer.js
import React18, { Component as Component8 } from "react";
import PropTypes15 from "prop-types";
import { connect as connect2 } from "react-redux";
import { bindActionCreators } from "redux";
import { JsonApiDecorator as JsonApiDecorator2 } from "@everfi/reactifi/dist/es/json-api/JsonApiDecorator";
import { ProgressSpinner as ProgressSpinner3 } from "@everfi/reactifi/dist/es/components/progress-spinner";
import { FAIcon as FAIcon2 } from "@everfi/reactifi/dist/es/components/fa-icon";
import { LanguageModal } from "@everfi/reactifi/dist/es/components/Modals/LanguageModal";
import { storage as ReactifiStorage } from "@everfi/reactifi/dist/es/utils/Storage";

// src/components/SignPolicies.js
import { sanitizeUrl } from "@braintree/sanitize-url";
import { Button } from "@everfi/reactifi";
import { AlertMessage } from "@everfi/reactifi/dist/es/components/AlertMessage";
import { ProgressSpinner } from "@everfi/reactifi/dist/es/components/progress-spinner";
import { AlertMessageTypes } from "@everfi/reactifi/dist/es/constants/index";
import { sanitize as sanitizeHTML } from "dompurify";

// src/lib/i18n.js
import { i18n } from "@everfi/reactifi/dist/es/i18n/translate";
(function () {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var currentLanguage, locale;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          currentLanguage = i18n.language;
          _context9.next = 3;
          return import( /* webpackChunkName: "content-player-locale-[request]" */"../locales/".concat(currentLanguage, "/translations.json"));
        case 3:
          locale = _context9.sent;
          i18n.addResources(i18n.language, "content-player", locale);
        case 5:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
})();
var t = function t(key, options) {
  return i18n.t(key, __spreadProps(__spreadValues({}, options), {
    ns: "content-player"
  }));
};

// src/components/SignPolicies.js
import PropTypes from "prop-types";
import { Component } from "react";
var SignPolicies = /*#__PURE__*/function (_Component) {
  function SignPolicies(props) {
    var _this;
    _classCallCheck(this, SignPolicies);
    _this = _callSuper(this, SignPolicies, [props]);
    _this.signCurrentPolicy = function () {
      return __async(_this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this$props, policies, progressId, signPolicy2, onComplete, activePolicy, response, nextPolicy;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this$props = this.props, policies = _this$props.policies, progressId = _this$props.progressId, signPolicy2 = _this$props.signPolicy, onComplete = _this$props.onComplete;
              activePolicy = this.state.activePolicy;
              this.setState({
                isLoading: true
              });
              _context10.next = 5;
              return signPolicy2(activePolicy.id, progressId);
            case 5:
              response = _context10.sent;
              this.setState({
                isLoading: false
              });
              if (response && response.ok) {
                nextPolicy = policies[policies.findIndex(function (policy) {
                  return policy.id === activePolicy.id;
                }) + 1];
                if (nextPolicy) {
                  this.setState({
                    activePolicy: nextPolicy,
                    policyLinkClicked: false
                  });
                } else {
                  onComplete();
                }
              }
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    };
    _this.enableSignature = function () {
      return _this.setState({
        policyLinkClicked: true
      });
    };
    _this.renderLinkElement = function (url, label) {
      return /* @__PURE__ */React.createElement("p", {
        className: "text-center"
      }, /* @__PURE__ */React.createElement("a", {
        className: "btn btn-secondary",
        href: sanitizeUrl(url),
        onClick: _this.enableSignature,
        rel: "noopener noreferrer",
        target: "_blank"
      }, label));
    };
    _this.state = {
      activePolicy: props.policies[0],
      policyLinkClicked: false,
      isLoading: false
    };
    return _this;
  }
  _inherits(SignPolicies, _Component);
  return _createClass(SignPolicies, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        policies = _this$props2.policies,
        errorMessage = _this$props2.errorMessage;
      var _this$state = this.state,
        activePolicy = _this$state.activePolicy,
        policyLinkClicked = _this$state.policyLinkClicked,
        isLoading = _this$state.isLoading;
      var current = policies.findIndex(function (policy) {
        return policy.id === activePolicy.id;
      }) + 1;
      if (!activePolicy) return null;
      return /* @__PURE__ */React.createElement("div", {
        className: "foundry"
      }, /* @__PURE__ */React.createElement("div", {
        className: "container"
      }, /* @__PURE__ */React.createElement("div", {
        className: "row"
      }, /* @__PURE__ */React.createElement("div", {
        className: "col-6 col-offset-3"
      }, /* @__PURE__ */React.createElement("div", {
        className: "card m-30"
      }, /* @__PURE__ */React.createElement("h3", {
        className: "text-center"
      }, t("Sign Policy {{currentPolicy}} of {{totalPolicies}}", {
        currentPolicy: current,
        totalPolicies: policies.length
      })), isLoading ? /* @__PURE__ */React.createElement(ProgressSpinner, null) : /* @__PURE__ */React.createElement("div", null, errorMessage && /* @__PURE__ */React.createElement(AlertMessage, {
        message: errorMessage,
        messageType: AlertMessageTypes.danger,
        visible: true
      }), /* @__PURE__ */React.createElement("p", {
        className: "text-center"
      }, t("Please review and acknowledge the policies to complete your training.")), activePolicy.url && this.renderLinkElement(activePolicy.url, t("View Policy Online")), activePolicy.media_url && this.renderLinkElement(activePolicy.media_url, t("Download PDF")), activePolicy.content && /* @__PURE__ */React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: sanitizeHTML(activePolicy.content)
        }
      }), /* @__PURE__ */React.createElement("div", {
        className: "text-end"
      }, /* @__PURE__ */React.createElement(Button, {
        className: "m-10",
        bsSize: "large",
        onClick: this.signCurrentPolicy,
        disabled: !activePolicy.content && !policyLinkClicked,
        label: t("I Acknowledge")
      }))))))));
    }
  }]);
}(Component);
SignPolicies.propTypes = {
  policies: PropTypes.array.isRequired,
  progressId: PropTypes.string.isRequired,
  signPolicy: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  onComplete: PropTypes.func.isRequired
};
var SignPolicies_default = SignPolicies;

// src/components/ContentGroup.js
import React4, { Component as Component2 } from "react";
import PropTypes4 from "prop-types";
import { connect } from "react-redux";
import { JsonApiDecorator } from "@everfi/reactifi/dist/es/json-api/JsonApiDecorator";
import { ProgressSpinner as ProgressSpinner2 } from "@everfi/reactifi/dist/es/components/progress-spinner";

// src/components/MaintenanceMode.js
import React3 from "react";
import PropTypes3 from "prop-types";

// src/components/ContentError.js
import React2 from "react";
import PropTypes2 from "prop-types";
import { FAIcon } from "@everfi/reactifi/dist/es/components/fa-icon";
var ContentError = function ContentError(_ref) {
  var children = _ref.children;
  return /* @__PURE__ */React2.createElement("div", {
    className: "foundry"
  }, /* @__PURE__ */React2.createElement("div", {
    className: "p-30 text-center f-20"
  }, /* @__PURE__ */React2.createElement(FAIcon, {
    icon: "triangle-exclamation",
    color: "yellow",
    additionalClasses: "m-r-5"
  }), children));
};
ContentError.propTypes = {
  children: PropTypes2.node
};
var ContentError_default = ContentError;

// src/components/MaintenanceMode.js
var MaintenanceMode = function MaintenanceMode(_ref2) {
  var name = _ref2.name;
  return /* @__PURE__ */React3.createElement(ContentError_default, null, name, " ", t("is temporarily unavailable. Please come back later. Additional information may be available on our "), /* @__PURE__ */React3.createElement("a", {
    href: "https://support.everfi.com",
    target: "_blank",
    className: "f-700 branded-link",
    rel: "noopener noreferrer"
  }, t("support site")), ".");
};
MaintenanceMode.propTypes = {
  name: PropTypes3.string
};
var MaintenanceMode_default = MaintenanceMode;

// src/components/ContentGroup.js
import isEqual from "lodash/isEqual";
function mapStateToProps(state, ownProps) {
  var props = {
    dispatch: state.dispatch,
    progress: ownProps.progress
  };
  var api2 = new JsonApiDecorator(state.api);
  if (api2.content_group_items) {
    props.content_group_items = api2.content_group_items.all({
      content: ["content_config"]
    });
  }
  return props;
}
var ContentGroup = /*#__PURE__*/function (_Component2) {
  function ContentGroup(props) {
    var _this2;
    _classCallCheck(this, ContentGroup);
    _this2 = _callSuper(this, ContentGroup, [props]);
    _this2.onComplete = function () {
      _this2.setState({
        advanceAfterVerification: true
      }, function () {
        if (!_this2.state.verifyingCompletion) {
          if (!_this2.state.reloadedProgress) {
            _this2.setState({
              reloadedProgress: true
            }, function () {
              return __async(_this2, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
                return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      _context11.next = 2;
                      return this.props.loadProgress(this.props.progress.id);
                    case 2:
                      this.advance();
                    case 3:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee11, this);
              }));
            });
          } else {
            _this2.advance();
          }
        }
      });
    };
    _this2.advance = function () {
      var oldPosition = _this2.state.position;
      var newPosition = _this2.state.position + 1;
      _this2.setState({
        advanceAfterVerification: false
      });
      if (newPosition >= _this2.state.items.length) {
        _this2.props.verifyProgressComplete(true);
      } else {
        var nestedProgress = _this2.getNestedProgress(oldPosition);
        if (nestedProgress) {
          if (nestedProgress.policies_missing) {
            _this2.setState({
              signingPolicies: true
            });
            return;
          } else if (nestedProgress.preview || nestedProgress.data.status === "completed") {
            _this2.setState({
              position: newPosition,
              advancing: false,
              reloadedProgress: false
            }, _this2.onContentChange);
            return;
          }
        }
        _this2.props.onComplete();
      }
    };
    _this2.verifyProgressComplete = function (advance) {
      _this2.setState({
        advanceAfterVerification: !!advance
      }, _this2.verifyNestedProgressComplete);
    };
    _this2.verifyNestedProgressComplete = function () {
      if (_this2.state.verifyingCompletion) {
        return;
      }
      _this2.setState({
        verifyingCompletion: true
      }, function () {
        _this2.props.pollProgress(function () {
          return __async(_this2, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
            return _regeneratorRuntime().wrap(function _callee12$(_context12) {
              while (1) switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.next = 2;
                  return this.props.loadProgress(this.props.progress.id);
                case 2:
                  return _context12.abrupt("return", _context12.sent);
                case 3:
                case "end":
                  return _context12.stop();
              }
            }, _callee12, this);
          }));
        }, _this2.shouldStopPolling, function () {
          _this2.setState({
            verifyingCompletion: false
          });
          if (_this2.state.advanceAfterVerification) {
            _this2.advance();
          }
        }, _this2.props.onCannotVerifyCompletion);
      });
    };
    _this2.shouldStopPolling = function () {
      if (_this2._destroyed) {
        return true;
      }
      var progress = _this2.getNestedProgress();
      if (!progress) {
        return false;
      }
      return progress.preview || progress.data.status === "completed" || progress.data.policies_missing;
    };
    _this2.shouldAdvance = function (position) {
      var nestedProgress = _this2.getNestedProgress(position);
      if (!nestedProgress) {
        return false;
      }
      return nestedProgress.preview || nestedProgress.status === "completed";
    };
    _this2.isEvaluation = function (contentType) {
      return ["assessment", "poll", "survey"].includes(contentType);
    };
    _this2.getNestedProgress = function (position) {
      if (typeof position === "undefined") {
        position = _this2.state.position;
      }
      if (_this2.state.items.length <= 0) return null;
      var item = _this2.state.items[position];
      var content = item.content;
      var nestedProgress = {
        content: content,
        id: _this2.props.progress.id,
        preview: _this2.props.progress.preview,
        learner_profile: _this2.props.progress.learner_profile,
        data: _this2.props.progress.data.items && _this2.props.progress.data.items[content.id] ? _this2.props.progress.data.items[content.id] : {}
      };
      nestedProgress.data.evaluations = nestedProgress.data.evaluations;
      return nestedProgress;
    };
    _this2.onContentChange = function () {
      var content = _this2.currentContent;
      _this2.props.onContentChange(content.id);
    };
    _this2.onSignPoliciesComplete = function () {
      _this2.setState({
        signingPolicies: false
      });
      _this2.verifyProgressComplete(true);
    };
    _this2.state = {
      items: [],
      position: -1,
      verifyingCompletion: false,
      reloadedProgress: false,
      advanceAfterVerification: false,
      signingPolicies: false
    };
    return _this2;
  }
  _inherits(ContentGroup, _Component2);
  return _createClass(ContentGroup, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._destroyed = true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadContentGroupItems(this.props.progress.content.id);
    }
    // eslint-disable-next-line sonarjs/cognitive-complexity
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      var _a;
      var _this$props3 = this.props,
        content_group_items = _this$props3.content_group_items,
        onComplete = _this$props3.onComplete,
        progress = _this$props3.progress;
      if (content_group_items && progress && !isEqual(prevProps.content_group_items, content_group_items)) {
        var completed = (_a = progress.data) == null ? void 0 : _a.completed;
        if (progress.preview) {
          completed = content_group_items.every(function (item) {
            var _a2, _b, _c, _d;
            if (_this3.isEvaluation((_a2 = item.content) == null ? void 0 : _a2.content_type)) {
              return true;
            } else if (((_b = progress.data) == null ? void 0 : _b.items) && ((_c = progress.data) == null ? void 0 : _c.items[item.content_id])) {
              return (_d = progress.data.items[item.content_id]) == null ? void 0 : _d.completed;
            }
          });
        }
        var items = content_group_items.map(function (item) {
          var _a2, _b, _c;
          if (progress.preview && _this3.isEvaluation((_a2 = item.content) == null ? void 0 : _a2.content_type)) {
            return;
          }
          if (((_c = (_b = progress.data) == null ? void 0 : _b.items[item.content_id]) == null ? void 0 : _c.status) === "skipped") {
            return;
          }
          if (completed && !_this3.isEvaluation(item.content.content_type)) {
            return item;
          }
          if (!progress.data.items) {
            return item;
          }
          var itemProgress = progress.data.items[item.content_id];
          if (!itemProgress || itemProgress && !itemProgress.completed) {
            return item;
          }
        });
        items = items.filter(function (i) {
          return i;
        });
        if (items == null ? void 0 : items.length) {
          this.setState({
            items: items,
            position: 0
          }, this.onContentChange);
        } else {
          onComplete();
        }
      }
    }
  }, {
    key: "currentContent",
    get: function get() {
      var _this$state2 = this.state,
        items = _this$state2.items,
        position = _this$state2.position;
      var item = items[position];
      return item.content;
    }
  }, {
    key: "render",
    value: function render() {
      var nestedProgress = this.getNestedProgress();
      if (!nestedProgress || this.state.advancing && this.state.verifyingCompletion) {
        return /* @__PURE__ */React4.createElement("div", {
          className: "foundry"
        }, /* @__PURE__ */React4.createElement(ProgressSpinner2, null), /* @__PURE__ */React4.createElement("div", {
          className: "text-center m-10 f-18"
        }, this.state.advancing ? t("Completing") : t("Loading"), "\u2026"));
      }
      var content = this.currentContent;
      if (content.maintenance) {
        return /* @__PURE__ */React4.createElement(MaintenanceMode_default, {
          name: content.name
        });
      }
      if (this.state.signingPolicies) {
        return /* @__PURE__ */React4.createElement(SignPolicies_default, {
          policies: nestedProgress.business_policies.filter(function (policy) {
            return policy.is_missing;
          }),
          progressId: nestedProgress.id,
          signPolicy: this.props.signPolicy,
          onComplete: this.onSignPoliciesComplete,
          errorMessage: this.props.errorMessage
        });
      }
      var Component9 = components_default[content.content_type];
      return /* @__PURE__ */React4.createElement(Component9, __spreadProps(__spreadValues({
        key: content.id
      }, this.props), {
        slug: content.evalufi_slug,
        progress: nestedProgress,
        verifyProgressComplete: this.verifyProgressComplete,
        onComplete: this.onComplete
      }));
    }
  }]);
}(Component2);
ContentGroup.propTypes = {
  dispatch: PropTypes4.func.isRequired,
  progress: PropTypes4.shape({
    content: PropTypes4.shape({
      id: PropTypes4.string,
      name: PropTypes4.string
    }),
    data: PropTypes4.shape({
      items: PropTypes4.object,
      completed: PropTypes4.bool,
      evaluations: PropTypes4.shape({
        token: PropTypes4.string,
        evalufi_host: PropTypes4.string
      })
    }),
    id: PropTypes4.string,
    learner_profile: PropTypes4.object,
    preview: PropTypes4.bool,
    status: PropTypes4.string
  }),
  content_group_items: PropTypes4.array,
  onComplete: PropTypes4.func,
  verifyProgressComplete: PropTypes4.func,
  onCannotVerifyCompletion: PropTypes4.func,
  onContentChange: PropTypes4.func,
  loadProgress: PropTypes4.func,
  loadContentGroupItems: PropTypes4.func,
  pollProgress: PropTypes4.func,
  contentServiceUrl: PropTypes4.string,
  accessToken: PropTypes4.string,
  signPolicy: PropTypes4.func,
  errorMessage: PropTypes4.string
};
var ContentGroup_default = connect(mapStateToProps)(ContentGroup);

// src/components/CourseModule.js
import React13, { Component as Component5 } from "react";
import PropTypes11 from "prop-types";

// src/components/CourseIFrame.js
import ahoy from "@everfi/foundry-analytics-js";
import React8, { Component as Component4 } from "react";
import PropTypes6 from "prop-types";
import deepmerge from "deepmerge";

// src/courseSettings.js
import { getUrlVars, PathHelper as PathHelper2 } from "@everfi/reactifi/dist/es/utils/UrlUtil";
import cloneDeep from "lodash/cloneDeep";
var isDomainEverFiSafe = function isDomainEverFiSafe(path) {
  var domainRegex = /^(http|https):\/\/+(([\w]+[.]fidev-.+)[.]net|(courses.fifoundry-.+)[.]net|everfi-curriculums.s3.amazonaws.com|.+[.]fidev.net|((localhost)[^.]*$))/gi;
  return domainRegex.test(path);
};
var customCoursePath = function customCoursePath() {
  var urlVars = getUrlVars(window.location.search);
  var path = urlVars.coursePath || localStorage.getItem("coursePath");
  var domainIsSafe = isDomainEverFiSafe(path);
  if (domainIsSafe) {
    return path;
  }
};
var customSDKPath = function customSDKPath() {
  var urlVars = getUrlVars(window.location.search);
  var path = urlVars.sdkPath || localStorage.getItem("sdkPath");
  var domainIsSafe = isDomainEverFiSafe(path);
  if (domainIsSafe) {
    return path;
  }
};
var courseSettings_default = function courseSettings_default(props) {
  var evaluations = props.progress.data.evaluations || {};
  Object.entries(evaluations).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    evaluations[key].id = evaluations[key].evalufi_id;
    evaluations[key].endpoint = "".concat(evaluations[key].evalufi_host, "/api/v1");
  });
  var courseUrl = customCoursePath() || props.progress.content.content_config.content_url;
  return {
    event_type: "launch-course",
    config: {
      enrollment: {
        // name: enrollment&.name,
        // id: 'preview',
        id: props.progress.id,
        demoMode: props.progress.preview,
        contentId: props.progress.content.id,
        state: props.progress.state
        // certified: enrollment.try(:certified?),
        // email: enrollment&.user&.anonymous? ? nil : enrollment&.email
      },
      settings: {
        local: false,
        env: "production",
        basePath: props.endpointUrl,
        portalBasePath: props.portalEndpointUrl,
        portalHeartbeat: props.portalHeartbeat,
        portalQueryString: props.portalQueryString,
        accessToken: props.accessToken,
        jwt: props.jwt,
        courseUrl: PathHelper2.ensureEndSlash(courseUrl),
        progressProvider: "content-service"
        // disableBranding: BrandingService.new(current_school, enrollment).branding_disabled?,
        // start_date: start_date
      },
      i18n: {
        // lng: I18n.locale
        lng: props.locale ? props.locale.replace("_", "-") : "en",
        lngs: props.locales || ["en"]
      },
      evaluations: cloneDeep(evaluations),
      learnerProfile: props.progress.learner_profile
      // other: other_options,
      //surveys: expand_activity_mapping(curriculum_config.surveys),
      // assessments: expand_activity_mapping(curriculum_config.assessments)
    }
  };
};

// src/components/Survey.js
import React6 from "react";

// src/components/ContentEvaluation.js
import React5, { Component as Component3, Suspense, lazy } from "react";
import PropTypes5 from "prop-types";
import isEqual2 from "lodash/isEqual";
var Evaluations = lazy(function () {
  return import("@everfi/evalufi-player");
});
var ContentEvaluation = /*#__PURE__*/function (_Component3) {
  function ContentEvaluation(props) {
    var _this4;
    _classCallCheck(this, ContentEvaluation);
    _this4 = _callSuper(this, ContentEvaluation, [props]);
    _this4.afterFinished = function () {
      if (_this4.props.verifyProgressComplete) {
        _this4.props.verifyProgressComplete(true);
      } else {
        _this4.props.onComplete();
      }
    };
    _this4.isEvaluable = function () {
      var evaluations = _this4.state.evaluations;
      return !!evaluations;
    };
    _this4.retryEvaluationWebhooks = function () {
      return __async(_this4, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this$props4, id, retryEvaluationWebhooks2, _this$state$evaluatio, evalufi_host, token, evalufi_id;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this$props4 = this.props, id = _this$props4.progress.id, retryEvaluationWebhooks2 = _this$props4.retryEvaluationWebhooks;
              _this$state$evaluatio = this.state.evaluations, evalufi_host = _this$state$evaluatio.evalufi_host, token = _this$state$evaluatio.token, evalufi_id = _this$state$evaluatio.evalufi_id;
              _context13.next = 4;
              return retryEvaluationWebhooks2(id, evalufi_id, "".concat(evalufi_host, "/api/v1"), token);
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    };
    _this4.state = {};
    return _this4;
  }
  _inherits(ContentEvaluation, _Component3);
  return _createClass(ContentEvaluation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this$props5, fetchMissingResponseSet2, data, slug, evaluations;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this$props5 = this.props, fetchMissingResponseSet2 = _this$props5.fetchMissingResponseSet, data = _this$props5.progress.data, slug = _this$props5.slug;
              evaluations = data.evaluations;
              if (!(!evaluations || !evaluations.evalufi_id)) {
                _context14.next = 6;
                break;
              }
              _context14.next = 5;
              return fetchMissingResponseSet2(slug);
            case 5:
              evaluations = _context14.sent;
            case 6:
              this.setState({
                evaluations: evaluations
              });
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!isEqual2(this.props.progress.data.evaluations, prevProps.progress.data.evaluations)) {
                this.setState({
                  evaluations: this.props.progress.data.evaluations
                });
              }
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.evaluations) return null;
      var _this$props6 = this.props,
        type = _this$props6.type,
        locale = _this$props6.locale,
        retakeEvaluation2 = _this$props6.retakeEvaluation;
      var _this$state$evaluatio2 = this.state.evaluations,
        evalufi_host = _this$state$evaluatio2.evalufi_host,
        token = _this$state$evaluatio2.token,
        evalufi_id = _this$state$evaluatio2.evalufi_id;
      var isEvaluable = this.isEvaluable();
      return /* @__PURE__ */React5.createElement("div", {
        className: type
      }, !isEvaluable ? /* @__PURE__ */React5.createElement("div", null, t("Evaluation components could not load")) : /* @__PURE__ */React5.createElement(Suspense, null, /* @__PURE__ */React5.createElement(Evaluations, {
        endpointHost: evalufi_host,
        endpointPath: "api/v1",
        language: locale,
        accessToken: token,
        primaryColor: this.props.primaryColor,
        secondaryColor: this.props.secondaryColor,
        responseSetId: evalufi_id,
        afterFinished: this.afterFinished,
        retakeEvaluation: retakeEvaluation2,
        retryEvaluationWebhooks: this.retryEvaluationWebhooks
      })));
    }
  }]);
}(Component3);
ContentEvaluation.propTypes = {
  fetchMissingResponseSet: PropTypes5.func,
  locale: PropTypes5.string,
  onComplete: PropTypes5.func.isRequired,
  primaryColor: PropTypes5.string,
  progress: PropTypes5.shape({
    id: PropTypes5.string,
    content: PropTypes5.shape({
      id: PropTypes5.string,
      name: PropTypes5.string,
      evalufi_slug: PropTypes5.string.isRequired
    }),
    data: PropTypes5.shape({
      evaluations: PropTypes5.shape({
        evalufi_host: PropTypes5.string.isRequired,
        evalufi_id: PropTypes5.string.isRequired,
        token: PropTypes5.string.isRequired
      }),
      completed: PropTypes5.bool
    })
  }),
  retakeEvaluation: PropTypes5.func,
  retryEvaluationWebhooks: PropTypes5.func,
  secondaryColor: PropTypes5.string,
  slug: PropTypes5.string,
  type: PropTypes5.string,
  verifyProgressComplete: PropTypes5.func
};

// src/components/Survey.js
var Survey = function Survey(props) {
  return /* @__PURE__ */React6.createElement(ContentEvaluation, __spreadValues({
    type: "survey"
  }, props));
};
var Survey_default = Survey;

// src/components/Assessment.js
import React7 from "react";
var Assessment = function Assessment(props) {
  return /* @__PURE__ */React7.createElement(ContentEvaluation, __spreadValues({
    type: "assessment"
  }, props));
};
var Assessment_default = Assessment;

// src/components/CourseIFrame.js
import { WindowHelper } from "@everfi/reactifi";
import { sanitizeUrl as sanitizeUrl2 } from "@braintree/sanitize-url";
var CourseIFrame = /*#__PURE__*/function (_Component4) {
  function CourseIFrame(props) {
    var _this5;
    _classCallCheck(this, CourseIFrame);
    _this5 = _callSuper(this, CourseIFrame, [props]);
    _this5.courseSettings = function () {
      var settings = deepmerge(courseSettings_default(_this5.props), _this5.props.overrideSettings);
      var split_module = _this5.props.progress.content.content_config.data.split_module;
      var _this5$props$progress = _this5.props.progress.content,
        content_type = _this5$props$progress.content_type,
        _this5$props$progress2 = _this5$props$progress.data,
        module_key = _this5$props$progress2.module_key,
        module_keys = _this5$props$progress2.module_keys;
      if (content_type === "course_module" && split_module) {
        settings.config.settings.split_module = module_key;
      }
      if (content_type === "course" && module_keys) {
        settings.config.settings.module_keys = {
          modules: module_keys
        };
      }
      if (_this5.props.progress.content.content_config.driver === "Leo") {
        settings.config.settings.basePath = settings.config.settings.basePath.replace("api/v1", "api/leo");
      }
      return settings;
    };
    _this5.onEvaluationComplete = function () {
      return __async(_this5, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var slug;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.props.loadProgress(this.props.progress.id);
            case 2:
              if (this.props.progress.data.evaluations) {
                slug = this.state.slug;
                if (slug) {
                  if (this.props.progress.data.evaluations[slug]) {
                    this.props.progress.data.evaluations[slug].completed = true;
                  } else {
                    this.props.progress.data.evaluations[slug] = {
                      completed: true
                    };
                  }
                }
              }
              this.renderCourseIframe();
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    };
    _this5.renderCourseIframe = function () {
      _this5.setState({
        component: null
      });
    };
    _this5.setStateForEvaluationComponents = function (componentToRender, data) {
      _this5.setState({
        component: componentToRender,
        redirectUrl: data.redirectUrl,
        slug: data.slug
      });
    };
    // eslint-disable-next-line
    _this5.postMessage = function (event) {
      var sdk_abilities;
      var windowHelper = WindowHelper.WindowHelperWrapper();
      switch (event.data.event_type) {
        case "course-initialized":
          _this5.iframe.contentWindow.postMessage(_this5.courseSettings(), "*");
          if (_this5.props.isIntegratedContent) {
            parent.postMessage({
              event_type: "integrated-content-init"
            }, "*");
            _this5.props.onIntegratedContentComplete();
          }
          break;
        case "survey-initialized":
          _this5.setStateForEvaluationComponents(Survey_default, event.data);
          break;
        case "assessment-initialized":
          _this5.setStateForEvaluationComponents(Assessment_default, event.data);
          break;
        case "content-progress":
          if (_this5.props.isIntegratedContent) {
            parent.postMessage({
              event_type: "integrated-content-progress"
            }, "*");
          }
          break;
        case "course-complete":
          _this5.props.verifyProgressComplete();
          break;
        case "content-complete":
          sdk_abilities = _this5.props.progress.content.sdk_abilities || [];
          if (sdk_abilities.includes("content_complete_support")) {
            _this5.props.verifyProgressComplete();
          } else {}
          break;
        case "close-content":
          if (_this5.props.onComplete) {
            _this5.props.onComplete();
          }
          break;
        case "safety-exit":
          if (_this5.props.onSafetyExit) {
            _this5.props.onSafetyExit(event.data.redirectUrl);
          } else if (_this5.props.isIntegratedContent) {
            parent.postMessage({
              event_type: "integrated-content-close"
            }, "*");
          }
          break;
        case "request:failed":
          if (event.data.status !== 401) return;
          if (!event.data.location) {
            windowHelper.reload();
            break;
          }
          windowHelper.redirect(sanitizeUrl2(event.data.location));
          break;
        case "track:view":
          ahoy.page = window.location.pathname + event.data.path;
          ahoy.trackView({
            user_content_id: event.data.enrollment.id,
            module: event.data.module,
            activity: event.data.activity,
            page: event.data.page
          });
          break;
      }
    };
    _this5.retakeEvaluation = function (slug) {
      return __async(_this5, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              this.setState({
                component: "div"
              }, function () {
                return __async(_this6, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
                  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        _context17.next = 2;
                        return this.props.retakeEvaluation(slug);
                      case 2:
                        this.setState({
                          component: Assessment_default
                        });
                      case 3:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee17, this);
                }));
              });
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    };
    _this5.renderEvaluationComponent = function () {
      var Component9 = _this5.state.component;
      var evaluations = _this5.props.progress.data.evaluations[_this5.state.slug];
      var progress = deepmerge({}, _this5.props.progress, {
        clone: true
      });
      progress.data.evaluations = evaluations;
      return /* @__PURE__ */React8.createElement(Component9, {
        fetchMissingResponseSet: _this5.props.fetchMissingResponseSet,
        locale: _this5.state.locale || _this5.props.locale,
        onComplete: _this5.onEvaluationComplete,
        progress: progress,
        retakeEvaluation: _this5.retakeEvaluation,
        retryEvaluationWebhooks: _this5.props.retryEvaluationWebhooks,
        slug: _this5.state.slug
      });
    };
    _this5.renderIFrame = function () {
      var _this5$state = _this5.state,
        iFrameUrl = _this5$state.iFrameUrl,
        redirectUrl = _this5$state.redirectUrl;
      var courseIframeUrl = redirectUrl ? "".concat(iFrameUrl.split("#")[0]).concat(redirectUrl) : iFrameUrl;
      var customPath = customCoursePath();
      if (customPath) {
        courseIframeUrl += (courseIframeUrl.includes("?") ? "&" : "?") + "coursePath=".concat(customPath);
      }
      return /* @__PURE__ */React8.createElement("iframe", {
        id: "course-iframe",
        title: t("EVERFI: Course Launcher"),
        className: _this5.props.className,
        src: courseIframeUrl,
        ref: function ref(iframe) {
          _this5.iframe = iframe;
        },
        frameBorder: 0,
        allowFullScreen: true,
        msallowfullscreen: true,
        webkitallowfullscreen: true
      });
    };
    var url = new URL([props.organizationSlug, "student", "contents", props.progress.content.id].join("/"), props.host);
    if (props.progress.content.data.course_map.key) {
      url.hash = props.progress.content.data.course_map.key;
    }
    _this5.state = {
      component: null,
      iFrameUrl: url.toString(),
      redirectUrl: "",
      slug: null
    };
    return _this5;
  }
  _inherits(CourseIFrame, _Component4);
  return _createClass(CourseIFrame, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("message", this.postMessage, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("message", this.postMessage, false);
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.component ? this.renderEvaluationComponent() : this.renderIFrame();
    }
  }]);
}(Component4);
CourseIFrame.propTypes = {
  className: PropTypes6.string,
  host: PropTypes6.string,
  fetchMissingResponseSet: PropTypes6.func,
  isIntegratedContent: PropTypes6.bool,
  loadProgress: PropTypes6.func.isRequired,
  locale: PropTypes6.string,
  onComplete: PropTypes6.func,
  onIntegratedContentComplete: PropTypes6.func,
  onSafetyExit: PropTypes6.func,
  organizationSlug: PropTypes6.string,
  overrideSettings: PropTypes6.object,
  progress: PropTypes6.shape({
    id: PropTypes6.string,
    content: PropTypes6.shape({
      id: PropTypes6.string,
      content_config: PropTypes6.shape({
        content_url: PropTypes6.string,
        driver: PropTypes6.string,
        data: PropTypes6.shape({
          split_module: PropTypes6["boolean"]
        })
      }),
      content_type: PropTypes6.string,
      data: PropTypes6.shape({
        module_key: PropTypes6.string,
        module_keys: PropTypes6.array,
        course_map: PropTypes6.oneOfType([PropTypes6.shape({
          key: PropTypes6.string
        }), PropTypes6.array])
      }),
      sdk_abilities: PropTypes6.arrayOf(PropTypes6.string)
    }),
    data: PropTypes6.shape({
      evaluations: PropTypes6.shape({
        endpoint: PropTypes6.string,
        token: PropTypes6.string
      })
    }),
    preview: PropTypes6.bool,
    state: PropTypes6.string
  }),
  retakeEvaluation: PropTypes6.func,
  retryEvaluationWebhooks: PropTypes6.func,
  verifyProgressComplete: PropTypes6.func
};
CourseIFrame.defaultProps = {
  overrideSettings: {}
};

// src/components/CourseInline.js
import React12 from "react";
import PropTypes10 from "prop-types";
import deepmerge4 from "deepmerge";

// src/components/CourseInlineSDK.js
import ahoy2 from "@everfi/foundry-analytics-js";
import React9 from "react";
import PropTypes7 from "prop-types";
import deepmerge2 from "deepmerge";
import { getUrlVars as getUrlVars2, PathHelper as PathHelper3 } from "@everfi/reactifi/dist/es/utils/UrlUtil";

// src/SDK.js
var getChaplin = function getChaplin() {
  return window.Chaplin || window.require("chaplin");
};
var getEF = function getEF() {
  if (window.EF) return window.EF;
  return window.require ? window.require("ef/ef")["default"] : {};
};
var getSdkInit = function getSdkInit() {
  return window.require("initialize");
};

// src/components/CourseInlineSDK.js
import { WindowHelper as WindowHelper2 } from "@everfi/reactifi";
import { sanitizeUrl as sanitizeUrl3 } from "@braintree/sanitize-url";
var CourseInlineSDK = /*#__PURE__*/function (_React9$Component) {
  function CourseInlineSDK(props) {
    var _this7;
    _classCallCheck(this, CourseInlineSDK);
    _this7 = _callSuper(this, CourseInlineSDK, [props]);
    _this7.initSDK = function () {
      var initObject = _this7.courseSettings();
      var sdkInitInstance = getSdkInit();
      sdkInitInstance.configure(initObject);
      _this7.subscriptions.forEach(function (subscriber) {
        var chaplinInstance = getChaplin();
        chaplinInstance.mediator.subscribe(subscriber.event, subscriber.fn);
      });
    };
    _this7.courseSettings = function () {
      var split_module = _this7.props.progress.content.content_config.data.split_module;
      var _this7$props$progress = _this7.props.progress.content,
        content_type = _this7$props$progress.content_type,
        _this7$props$progress2 = _this7$props$progress.data,
        module_key = _this7$props$progress2.module_key,
        module_keys = _this7$props$progress2.module_keys;
      var settings = deepmerge2(courseSettings_default(_this7.props), _this7.props.overrideSettings || {});
      if (content_type === "course_module" && split_module) {
        settings.config.settings.split_module = module_key;
      }
      if (content_type === "course" && module_keys) {
        settings.config.settings.module_keys = {
          modules: module_keys
        };
      }
      settings.config.settings.container = "#course-container";
      return settings;
    };
    _this7.sendInterstitialEventToAhoy = function (eventType, customization_id) {
      if (typeof ahoy2 !== "undefined") {
        ahoy2.track("custom-interstitial-event", {
          event_target: "interstitial-page",
          event_type: eventType,
          customization_id: customization_id
        });
      }
    };
    _this7.subscriptions = [{
      event: "track:view",
      fn: function fn(event) {
        if (typeof ahoy2 !== "undefined") {
          ahoy2.page = window.location.pathname + event.data.path;
          ahoy2.trackView({
            user_content_id: event.data.enrollment.id,
            module: event.data.module,
            activity: event.data.activity,
            page: event.data.page
          });
        }
      }
    }, {
      event: "request:failed",
      fn: function fn(event) {
        if (event.data.status !== 401) return;
        var windowHelper = WindowHelper2.WindowHelperWrapper();
        if (!event.data.location) {
          windowHelper.reload();
          return;
        }
        windowHelper.redirect(sanitizeUrl3(event.data.location));
      }
    }, {
      event: "page:state:loaded",
      fn: function fn(page) {
        var url = _this7.props.iframed ? window.parent.location.pathname : window.location.pathname;
        if (typeof ahoy2 !== "undefined") {
          ahoy2.configure({
            page: url + "#" + page.model.path()
          });
          if (ahoy2.setEverfiMetadata && typeof ahoy2.setEverfiMetadata === "function") {
            ahoy2.setEverfiMetadata("module_key", page.model.get("moduleKey"));
            ahoy2.setEverfiMetadata("activity_key", page.model.get("activityKey"));
            ahoy2.setEverfiMetadata("page_key", page.model.get("key"));
          }
          ahoy2.trackView();
        }
      }
    }, {
      event: "interstitial-page:view",
      fn: function fn(customization_id) {
        _this7.sendInterstitialEventToAhoy("view", customization_id);
      }
    }, {
      event: "interstitial-page:done",
      fn: function fn(customization_id) {
        _this7.sendInterstitialEventToAhoy("done", customization_id);
      }
    }, {
      event: "interstitial-page:external-link-clicked",
      fn: function fn(customization_id) {
        _this7.sendInterstitialEventToAhoy("external-link-clicked", customization_id);
      }
    }];
    var SCRIPT_NAMES = ["vendor", "ef", "everfi-sdk", "app"];
    var STYLE_NAMES = ["vendor", "everfi-sdk", "main"];
    var split_module = _this7.props.progress.content.content_config.data.split_module;
    var _this7$props$progress3 = _this7.props.progress.content,
      content_type = _this7$props$progress3.content_type,
      module_key = _this7$props$progress3.data.module_key;
    _this7.urlVars = getUrlVars2(window.location.search);
    SCRIPT_NAMES.forEach(function (name) {
      var script = document.createElement("script");
      script.src = _this7.assetUrl("javascripts", "js", name);
      script.async = false;
      if (name === "app") {
        script.onload = function () {
          _this7.initSDK();
        };
        if (split_module && module_key) {
          script.src = _this7.assetUrl("modules/".concat(module_key, "/javascripts"), "js", "app");
        }
      }
      document.body.appendChild(script);
    });
    STYLE_NAMES.forEach(function (name) {
      var link = document.createElement("link");
      if (content_type === "course_module" && split_module && name === "main") {
        link.href = _this7.assetUrl("modules/".concat(module_key, "/stylesheets"), "css", "main");
      } else {
        link.href = _this7.assetUrl("stylesheets", "css", name);
      }
      link.media = "screen";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    });
    return _this7;
  }
  _inherits(CourseInlineSDK, _React9$Component);
  return _createClass(CourseInlineSDK, [{
    key: "assetUrl",
    value: function assetUrl(type, extension, name) {
      var fileName = "".concat(name, ".").concat(extension);
      var urlArray;
      var customPath = customCoursePath();
      if (customPath) {
        urlArray = [PathHelper3.ensureNoEndSlash(customPath)];
      } else {
        var _this$props$progress$ = this.props.progress.content.content_config.data,
          data_folder = _this$props$progress$.data_folder,
          data_url = _this$props$progress$.data_url,
          data_version = _this$props$progress$.data_version;
        urlArray = [data_url, data_folder, data_version];
      }
      urlArray.push(type);
      urlArray.push(fileName);
      urlArray = urlArray.filter(function (chunk) {
        return chunk !== void 0 && chunk !== "";
      }).join("/");
      return new URL(urlArray).toString();
    }
  }, {
    key: "render",
    value: function render() {
      var style = !this.props.visible ? {
        display: "none"
      } : {};
      return /* @__PURE__ */React9.createElement("div", {
        className: this.props.className,
        id: "course-container",
        style: style
      });
    }
  }]);
}(React9.Component);
CourseInlineSDK.propTypes = {
  className: PropTypes7.string,
  iframed: PropTypes7.bool,
  overrideSettings: PropTypes7.object,
  progress: PropTypes7.shape({
    id: PropTypes7.string,
    data: PropTypes7.shape({
      evaluations: PropTypes7.object
    }),
    content: PropTypes7.shape({
      id: PropTypes7.string,
      data: PropTypes7.shape({
        module_key: PropTypes7.string,
        module_keys: PropTypes7.array
      }),
      content_config: PropTypes7.shape({
        driver: PropTypes7.string,
        data: PropTypes7.shape({
          data_folder: PropTypes7.string,
          data_url: PropTypes7.string,
          data_version: PropTypes7.string,
          split_module: PropTypes7.string
        })
      }),
      content_type: PropTypes7.string
    })
  }),
  visible: PropTypes7.bool
};

// src/components/CourseInlineLeo.js
import { sanitizeUrl as sanitizeUrl4 } from "@braintree/sanitize-url";
import { WindowHelper as WindowHelper3 } from "@everfi/reactifi";
import deepmerge3 from "deepmerge";
import PropTypes8 from "prop-types";
import React10 from "react";
var CourseInlineLeo = /*#__PURE__*/function (_React10$Component) {
  function CourseInlineLeo() {
    var _this8;
    _classCallCheck(this, CourseInlineLeo);
    _this8 = _callSuper(this, CourseInlineLeo, arguments);
    _this8.courseSettings = function () {
      var settings = deepmerge3(courseSettings_default(_this8.props), _this8.props.overrideSettings || {});
      settings.config.settings.basePath = settings.config.settings.basePath.replace("api/v1", "api/leo");
      return settings;
    };
    _this8.postMessage = function (event) {
      var windowHelper = WindowHelper3.WindowHelperWrapper();
      switch (event.data.event_type) {
        case "course-initialized":
          _this8.iframe.contentWindow.postMessage(_this8.courseSettings(), "*");
          break;
        case "request:failed":
          if (event.data.status !== 401) break;
          if (!event.data.location) {
            windowHelper.reload();
            break;
          }
          windowHelper.redirect(sanitizeUrl4(event.data.location));
          break;
      }
    };
    return _this8;
  }
  _inherits(CourseInlineLeo, _React10$Component);
  return _createClass(CourseInlineLeo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("message", this.postMessage, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("message", this.postMessage, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;
      var _a, _b;
      var _this$props7 = this.props,
        visible = _this$props7.visible,
        progress = _this$props7.progress,
        className = _this$props7.className,
        redirectUrl = _this$props7.redirectUrl;
      var pathData = (_b = (_a = progress == null ? void 0 : progress.content) == null ? void 0 : _a.content_config) == null ? void 0 : _b.data;
      if (!visible || !pathData) {
        return null;
      }
      var data_url = pathData.data_url,
        data_folder = pathData.data_folder,
        data_version = pathData.data_version;
      var encodedRedirect = redirectUrl ? encodeURIComponent(redirectUrl) : "";
      var iFrameUrl = "".concat(data_url, "/").concat(data_folder, "/").concat(data_version, "/Viewer/index.html").concat(encodedRedirect);
      return /* @__PURE__ */React10.createElement("iframe", {
        id: "course-iframe",
        className: className,
        src: sanitizeUrl4(iFrameUrl),
        ref: function ref(iframe) {
          _this9.iframe = iframe;
        },
        frameBorder: 0,
        style: {
          border: "none"
        }
      });
    }
  }]);
}(React10.Component);
CourseInlineLeo.propTypes = {
  className: PropTypes8.string,
  overrideSettings: PropTypes8.object,
  progress: PropTypes8.shape({
    id: PropTypes8.string,
    data: PropTypes8.shape({
      evaluations: PropTypes8.object
    }),
    content: PropTypes8.shape({
      id: PropTypes8.string,
      content_config: PropTypes8.shape({
        driver: PropTypes8.string,
        data: PropTypes8.shape({
          data_folder: PropTypes8.string,
          data_url: PropTypes8.string,
          data_version: PropTypes8.string
        })
      })
    })
  }),
  redirectUrl: PropTypes8.string,
  visible: PropTypes8.bool
};

// src/components/CourseInlineReact.js
import React11, { Suspense as Suspense2, lazy as lazy2 } from "react";
import PropTypes9 from "prop-types";
var CourseInlineReact = function CourseInlineReact(props) {
  var _courseSettings_defau = courseSettings_default(props),
    config = _courseSettings_defau.config;
  var sdk_web_path = props.progress.content.content_config.sdk_web_path;
  var sdkPath = customSDKPath() || sdk_web_path;
  window.global = window;
  var SDKWeb = lazy2(function () {
    return import( /* webpackIgnore: true */
    sdkPath);
  });
  return /* @__PURE__ */React11.createElement(Suspense2, {
    fallback: /* @__PURE__ */React11.createElement("div", null)
  }, /* @__PURE__ */React11.createElement(SDKWeb, {
    config: config
  }));
};
CourseInlineReact.propTypes = {
  progress: PropTypes9.shape({
    content: PropTypes9.shape({
      content_config: PropTypes9.shape({
        sdk_web_path: PropTypes9.string
      })
    })
  })
};
var CourseInlineReact_default = CourseInlineReact;

// src/components/CourseInlineComponents.js
var CourseInlineComponents_default = {
  sdk: CourseInlineSDK,
  leo: CourseInlineLeo,
  react: CourseInlineReact_default
};

// src/components/CourseInline.js
import { WindowHelper as WindowHelper4 } from "@everfi/reactifi";
import { sanitizeUrl as sanitizeUrl5 } from "@braintree/sanitize-url";
var CourseInline = /*#__PURE__*/function (_React12$Component) {
  function CourseInline(props) {
    var _this10;
    _classCallCheck(this, CourseInline);
    _this10 = _callSuper(this, CourseInline, [props]);
    _this10.isAllContentComplete = function () {
      var efInstance = getEF();
      if (_typeof(efInstance) !== "object") return false;
      return efInstance.modules.every(function (module) {
        return module.isComplete() || module.get("skip_activity_progress");
      });
    };
    _this10.onSDKCourseLoaded = function () {
      if (_this10.props.isIntegratedContent && _this10.isAllContentComplete()) {
        _this10.props.onIntegratedContentComplete();
      }
    };
    // eslint-disable-next-line
    _this10.postMessage = function (event) {
      return __async(_this10, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var sdk_abilities, _this$props8, loadProgress2, onSafetyExit, progress, verifyProgressComplete, data, windowHelper;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this$props8 = this.props, loadProgress2 = _this$props8.loadProgress, onSafetyExit = _this$props8.onSafetyExit, progress = _this$props8.progress, verifyProgressComplete = _this$props8.verifyProgressComplete;
              data = event.data;
              windowHelper = WindowHelper4.WindowHelperWrapper();
              _context19.t0 = data.event_type;
              _context19.next = _context19.t0 === "survey-initialized" ? 6 : _context19.t0 === "assessment-initialized" ? 8 : _context19.t0 === "course-complete" ? 12 : _context19.t0 === "content-complete" ? 14 : _context19.t0 === "close-content" ? 17 : _context19.t0 === "set-locale" ? 19 : _context19.t0 === "safety-exit" ? 21 : _context19.t0 === "request:failed" ? 23 : 30;
              break;
            case 6:
              this.setState({
                component: "survey",
                redirectUrl: data.redirectUrl,
                slug: data.slug
              });
              return _context19.abrupt("break", 30);
            case 8:
              _context19.next = 10;
              return loadProgress2(progress.id);
            case 10:
              this.setState({
                component: "assessment",
                redirectUrl: data.redirectUrl,
                slug: data.slug
              });
              return _context19.abrupt("break", 30);
            case 12:
              verifyProgressComplete();
              return _context19.abrupt("break", 30);
            case 14:
              sdk_abilities = progress.content.sdk_abilities || [];
              if (sdk_abilities.includes("content_complete_support")) {
                verifyProgressComplete();
              } else {
                if (this.isAllContentComplete()) {
                  verifyProgressComplete();
                }
              }
              return _context19.abrupt("break", 30);
            case 17:
              this.closeContent();
              return _context19.abrupt("break", 30);
            case 19:
              this.setState({
                locale: data.locale
              });
              return _context19.abrupt("break", 30);
            case 21:
              if (onSafetyExit) {
                onSafetyExit(data.redirectUrl);
              }
              return _context19.abrupt("break", 30);
            case 23:
              if (!(event.data.status !== 401)) {
                _context19.next = 25;
                break;
              }
              return _context19.abrupt("break", 30);
            case 25:
              if (event.data.location) {
                _context19.next = 28;
                break;
              }
              windowHelper.reload();
              return _context19.abrupt("break", 30);
            case 28:
              windowHelper.redirect(sanitizeUrl5(event.data.location));
              return _context19.abrupt("break", 30);
            case 30:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
    };
    _this10.closeContent = function () {
      var closehandler = _this10.props.onComplete || function () {};
      closehandler();
    };
    _this10.onEvaluationComplete = function () {
      return __async(_this10, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var _this11 = this;
        var response_set, slug, _this$props9, data, fetchMissingResponseSet2;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              slug = this.state.slug;
              _this$props9 = this.props, data = _this$props9.progress.data, fetchMissingResponseSet2 = _this$props9.fetchMissingResponseSet;
              if (!slug) {
                _context20.next = 12;
                break;
              }
              if (!(!data.evaluations || !data.evaluations[slug] || !data.evaluations[slug].evalufi_id)) {
                _context20.next = 9;
                break;
              }
              _context20.next = 6;
              return fetchMissingResponseSet2(slug);
            case 6:
              response_set = _context20.sent;
              _context20.next = 10;
              break;
            case 9:
              response_set = data.evaluations[slug];
            case 10:
              response_set.id = response_set.evalufi_id;
              response_set.endpoint = "".concat(response_set.evalufi_host, "/api/v1");
            case 12:
              window.parent.postMessage({
                event_type: "reload-evaluation",
                slug: this.state.slug,
                response_set: response_set
              }, "*");
              _context20.next = 15;
              return this.props.loadProgress(this.props.progress.id);
            case 15:
              data = this.props.progress.data;
              if (!slug) {
                _context20.next = 24;
                break;
              }
              if (!(!data.evaluations || !data.evaluations[slug] || !data.evaluations[slug].evalufi_id)) {
                _context20.next = 23;
                break;
              }
              _context20.next = 20;
              return fetchMissingResponseSet2(slug);
            case 20:
              data.evaluations[slug] = _context20.sent;
              _context20.next = 24;
              break;
            case 23:
              data.evaluations[slug].completed = true;
            case 24:
              this.setState({
                component: "course"
              }, function () {
                window.location.hash = _this11.state.redirectUrl + (_this11.state.redirectUrl.includes("?") ? "&" : "?") + "evaluationComplete=true";
              });
            case 25:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
    };
    _this10.buildEvaluationProgress = function () {
      var data = _this10.props.progress.data;
      var evaluations = data.evaluations && data.evaluations[_this10.state.slug];
      if (!evaluations) {
        console.warn("No evaluations found for slug ".concat(_this10.state.slug, ". Is the course misconfigured?"));
      }
      var progress = deepmerge4({}, _this10.props.progress, {
        clone: true
      });
      progress.data.evaluations = evaluations;
      return progress;
    };
    _this10.retakeEvaluation = function (slug) {
      return __async(_this10, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              this.setState({
                component: null
              });
              _context21.next = 3;
              return this.props.retakeEvaluation(slug);
            case 3:
              this.setState({
                component: "assessment"
              });
            case 4:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
    };
    _this10.survey = function () {
      var progress = _this10.buildEvaluationProgress();
      return /* @__PURE__ */React12.createElement(Survey_default, {
        fetchMissingResponseSet: _this10.props.fetchMissingResponseSet,
        locale: _this10.state.locale || _this10.props.locale,
        onComplete: _this10.onEvaluationComplete,
        progress: progress,
        retryEvaluationWebhooks: _this10.props.retryEvaluationWebhooks,
        slug: _this10.state.slug
      });
    };
    _this10.assessment = function () {
      var progress = _this10.buildEvaluationProgress();
      return /* @__PURE__ */React12.createElement(Assessment_default, {
        fetchMissingResponseSet: _this10.props.fetchMissingResponseSet,
        locale: _this10.state.locale || _this10.props.locale,
        onComplete: _this10.onEvaluationComplete,
        progress: progress,
        retakeEvaluation: _this10.retakeEvaluation,
        retryEvaluationWebhooks: _this10.props.retryEvaluationWebhooks,
        slug: _this10.state.slug
      });
    };
    _this10.course = function () {
      var Component9 = CourseInlineComponents_default[_this10.props.progress.content.content_config.driver.toLowerCase()];
      return /* @__PURE__ */React12.createElement(Component9, __spreadProps(__spreadValues({}, _this10.props), {
        visible: _this10.state.component === "course",
        redirectUrl: _this10.state.redirectUrl
      }));
    };
    _this10.state = {
      component: "course",
      redirectUrl: "",
      slug: null,
      locale: null
    };
    return _this10;
  }
  _inherits(CourseInline, _React12$Component);
  return _createClass(CourseInline, [{
    key: "courseSettings",
    value: function courseSettings() {
      return deepmerge4(courseSettings_default(this.props), this.props.overrideSettings || {});
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("message", this.postMessage, false);
      var efInstance = getEF();
      if (efInstance.on) {
        efInstance.on("ready", this.onSDKCourseLoaded);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("message", this.postMessage, false);
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */React12.createElement("div", null, this.state.component !== "course" && this[this.state.component] && this[this.state.component](), this.course());
    }
  }]);
}(React12.Component);
CourseInline.propTypes = {
  fetchMissingResponseSet: PropTypes10.func,
  loadProgress: PropTypes10.func,
  locale: PropTypes10.string,
  onComplete: PropTypes10.func,
  onSafetyExit: PropTypes10.func,
  overrideSettings: PropTypes10.object,
  progress: PropTypes10.shape({
    id: PropTypes10.string,
    data: PropTypes10.shape({
      evaluations: PropTypes10.object
    }),
    content: PropTypes10.shape({
      id: PropTypes10.string,
      content_config: PropTypes10.shape({
        driver: PropTypes10.string,
        data: PropTypes10.shape({
          data_folder: PropTypes10.string,
          data_url: PropTypes10.string,
          data_version: PropTypes10.string
        })
      }),
      sdk_abilities: PropTypes10.arrayOf(PropTypes10.string)
    })
  }),
  retakeEvaluation: PropTypes10.func,
  retryEvaluationWebhooks: PropTypes10.func,
  verifyProgressComplete: PropTypes10.func
};

// src/components/CourseModule.js
var CourseModule = /*#__PURE__*/function (_Component5) {
  function CourseModule() {
    _classCallCheck(this, CourseModule);
    return _callSuper(this, CourseModule, arguments);
  }
  _inherits(CourseModule, _Component5);
  return _createClass(CourseModule, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var module_key = this.props.progress.content.data.module_key;
      var hashAlreadySet = window.location.hash && window.location.hash.includes(module_key);
      if (!this.props.iframed && !hashAlreadySet) {
        window.location.hash = module_key;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var courseSettings = {
        config: {
          settings: {
            menuOverride: {
              postMessage: "close-content"
            }
          }
        }
      };
      var driver = this.props.progress.content.content_config.driver.toLowerCase();
      return this.props.iframed ? /* @__PURE__ */React13.createElement(CourseIFrame, __spreadProps(__spreadValues({
        className: "iframe-".concat(driver)
      }, this.props), {
        overrideSettings: courseSettings
      })) : /* @__PURE__ */React13.createElement(CourseInline, __spreadProps(__spreadValues({
        className: "inline-".concat(driver)
      }, this.props), {
        overrideSettings: courseSettings
      }));
    }
  }]);
}(Component5);
CourseModule.propTypes = {
  progress: PropTypes11.shape({
    content: PropTypes11.shape({
      id: PropTypes11.string.isRequired,
      content_config: PropTypes11.shape({
        driver: PropTypes11.string,
        content_url: PropTypes11.string
      }),
      data: PropTypes11.shape({
        module_key: PropTypes11.string,
        course_map: PropTypes11.shape({
          key: PropTypes11.string
        })
      })
    })
  }),
  iframed: PropTypes11.bool
};
CourseModule.defaultProps = {
  iframed: true
};

// src/components/Course.js
import React14 from "react";
import PropTypes12 from "prop-types";
var Course = /*#__PURE__*/function (_React14$Component) {
  function Course() {
    _classCallCheck(this, Course);
    return _callSuper(this, Course, arguments);
  }
  _inherits(Course, _React14$Component);
  return _createClass(Course, [{
    key: "render",
    value: function render() {
      var driver = this.props.progress.content.content_config.driver.toLowerCase();
      return this.props.iframed ? /* @__PURE__ */React14.createElement(CourseIFrame, __spreadValues({
        className: "iframe-".concat(driver)
      }, this.props)) : /* @__PURE__ */React14.createElement(CourseInline, __spreadValues({
        className: "inline-".concat(driver)
      }, this.props));
    }
  }]);
}(React14.Component);
Course.propTypes = {
  progress: PropTypes12.shape({
    id: PropTypes12.string,
    content: PropTypes12.shape({
      content_config: PropTypes12.shape({
        driver: PropTypes12.string
      })
    })
  }),
  iframed: PropTypes12.bool
};
Course.defaultProps = {
  iframed: true
};

// src/components/Poll.js
import React15 from "react";
var Poll = function Poll(props) {
  return /* @__PURE__ */React15.createElement(ContentEvaluation, __spreadValues({
    type: "survey"
  }, props));
};
var Poll_default = Poll;

// src/components/ContentArticle.js
import React16, { Component as Component6 } from "react";
import PropTypes13 from "prop-types";
var ContentArticle = /*#__PURE__*/function (_Component6) {
  function ContentArticle(props) {
    _classCallCheck(this, ContentArticle);
    return _callSuper(this, ContentArticle, [props]);
  }
  _inherits(ContentArticle, _Component6);
  return _createClass(ContentArticle, [{
    key: "render",
    value: function render() {
      var article = this.props.progress && this.props.progress.rendered_draft_source;
      var article_theme = this.props.progress && this.props.progress.theme_style;
      var _this$props10 = this.props,
        saveProgress2 = _this$props10.saveProgress,
        endpointUrl = _this$props10.endpointUrl,
        accessToken = _this$props10.accessToken,
        progress_id = _this$props10.progress.id;
      saveProgress2(progress_id, "article_progress", endpointUrl, accessToken);
      if (article) {
        return /* @__PURE__ */React16.createElement("div", null, /* @__PURE__ */React16.createElement("style", null, article_theme), /* @__PURE__ */React16.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: article
          }
        }));
      } else {
        return /* @__PURE__ */React16.createElement("div", null, t("Loading..."));
      }
    }
  }]);
}(Component6);
ContentArticle.propTypes = {
  accessToken: PropTypes13.string.isRequired,
  endpointUrl: PropTypes13.string,
  progress: PropTypes13.object,
  saveProgress: PropTypes13.func.isRequired
};
var ContentArticle_default = ContentArticle;

// src/components/ThirdPartyJsCss.js
import React17, { Component as Component7 } from "react";
import PropTypes14 from "prop-types";
var ThirdPartyJsCss = /*#__PURE__*/function (_Component7) {
  function ThirdPartyJsCss(props) {
    var _this12;
    _classCallCheck(this, ThirdPartyJsCss);
    _this12 = _callSuper(this, ThirdPartyJsCss, [props]);
    _this12.addJsCss = function (content_url, css_file, js_file) {
      try {
        if (css_file) {
          var link = document.createElement("link");
          link.href = "".concat(content_url, "/").concat(css_file);
          link.media = "screen";
          link.rel = "stylesheet";
          document.head.appendChild(link);
        }
        var script = document.createElement("script");
        script.src = "".concat(content_url, "/").concat(js_file);
        script.async = false;
        script.onload = function () {
          _this12.setState({
            loaded: true
          }, _this12.saveProgress);
        };
        document.body.appendChild(script);
      } catch (e) {
        console.log(e);
      }
    };
    _this12.saveProgress = function () {
      var _this12$props = _this12.props,
        saveProgress2 = _this12$props.saveProgress,
        endpointUrl = _this12$props.endpointUrl,
        accessToken = _this12$props.accessToken,
        progress_id = _this12$props.progress.id;
      saveProgress2(progress_id, "third_party_js_css_progress", endpointUrl, accessToken);
    };
    _this12.state = {};
    var _props$progress$conte = props.progress.content,
      _props$progress$conte2 = _props$progress$conte.data,
      js_file = _props$progress$conte2.js_file,
      css_file = _props$progress$conte2.css_file,
      content_url = _props$progress$conte.content_config.content_url;
    _this12.addJsCss(content_url, css_file, js_file);
    return _this12;
  }
  _inherits(ThirdPartyJsCss, _Component7);
  return _createClass(ThirdPartyJsCss, [{
    key: "render",
    value: function render() {
      if (this.state.loaded) {
        var _this$props$progress$2 = this.props.progress.content.data,
          library_name = _this$props$progress$2.library_name,
          component_name = _this$props$progress$2.component_name;
        if (window[library_name]) {
          var LibraryComponent = window[library_name][component_name];
          return /* @__PURE__ */React17.createElement(LibraryComponent, {
            lang: this.props.locale
          });
        } else {
          return /* @__PURE__ */React17.createElement("div", null, "an error happened");
        }
      } else {
        return /* @__PURE__ */React17.createElement("div", null);
      }
    }
  }]);
}(Component7);
ThirdPartyJsCss.propTypes = {
  endpointUrl: PropTypes14.string.isRequired,
  accessToken: PropTypes14.string.isRequired,
  saveProgress: PropTypes14.func.isRequired,
  locale: PropTypes14.string,
  progress: PropTypes14.shape({
    content: PropTypes14.shape({
      id: PropTypes14.string.isRequired,
      content_config: PropTypes14.shape({
        content_url: PropTypes14.string
      }),
      data: PropTypes14.shape({
        js_file: PropTypes14.string,
        css_file: PropTypes14.string,
        library_name: PropTypes14.string,
        component_name: PropTypes14.string
      })
    }),
    id: PropTypes14.string
  })
};

// src/components/index.js
var components_default = {
  group: ContentGroup_default,
  assessment: Assessment_default,
  survey: Survey_default,
  poll: Poll_default,
  course_module: CourseModule,
  course: Course,
  article: ContentArticle_default,
  third_party_js_css: ThirdPartyJsCss
};

// src/evalufi.js
import { loadExternalData as loadExternalData2, requestExternalData } from "@everfi/reactifi/dist/es/utils/ApiUtil";
import { loadScript } from "@everfi/reactifi/dist/es/utils/UrlUtil";
var fetchMissingResponseSet = function fetchMissingResponseSet(slug, progressId, contentServiceUrl, token) {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
    var endpoint, timeoutInterval, GET, POST, tries, foundResponseSet, fetchResponseSet;
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          endpoint = "".concat(contentServiceUrl, "api/v1/progress/").concat(progressId, "/response_sets");
          timeoutInterval = 1e3;
          GET = "GET";
          POST = "POST";
          tries = 3;
          fetchResponseSet = function fetchResponseSet(method) {
            return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
              var response, options;
              return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                while (1) switch (_context22.prev = _context22.next) {
                  case 0:
                    if (!(method === GET)) {
                      _context22.next = 30;
                      break;
                    }
                    _context22.prev = 1;
                    _context22.next = 4;
                    return loadExternalData2("".concat(endpoint, "/").concat(slug), token, true);
                  case 4:
                    response = _context22.sent;
                    _context22.next = 28;
                    break;
                  case 7:
                    _context22.prev = 7;
                    _context22.t0 = _context22["catch"](1);
                    if (!(_context22.t0.response.status === 404 || _context22.t0.response.status >= 500)) {
                      _context22.next = 18;
                      break;
                    }
                    _context22.t1 = setTimeout;
                    _context22.next = 13;
                    return fetchResponseSet(POST);
                  case 13:
                    _context22.t2 = _context22.sent;
                    _context22.t3 = timeoutInterval;
                    (0, _context22.t1)(_context22.t2, _context22.t3);
                    _context22.next = 28;
                    break;
                  case 18:
                    if (!(_context22.t0.response.status === 409)) {
                      _context22.next = 27;
                      break;
                    }
                    _context22.t4 = setTimeout;
                    _context22.next = 22;
                    return fetchResponseSet(GET);
                  case 22:
                    _context22.t5 = _context22.sent;
                    _context22.t6 = timeoutInterval;
                    (0, _context22.t4)(_context22.t5, _context22.t6);
                    _context22.next = 28;
                    break;
                  case 27:
                    throw _context22.t0;
                  case 28:
                    _context22.next = 34;
                    break;
                  case 30:
                    options = {
                      body: JSON.stringify({
                        data: {
                          type: "response_sets",
                          attributes: {
                            course_evaluation_slug: slug
                          }
                        }
                      })
                    };
                    _context22.next = 33;
                    return requestExternalData(endpoint, token, true, method, options);
                  case 33:
                    response = _context22.sent;
                  case 34:
                    tries--;
                    if (!(tries === 0)) {
                      _context22.next = 37;
                      break;
                    }
                    throw new Error("Re-tried and failed to get response set");
                  case 37:
                    if (response && response.id) {
                      foundResponseSet = response;
                    }
                  case 38:
                  case "end":
                    return _context22.stop();
                }
              }, _callee22, null, [[1, 7]]);
            }));
          };
          _context23.next = 8;
          return fetchResponseSet(GET);
        case 8:
          return _context23.abrupt("return", foundResponseSet);
        case 9:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
};

// src/containers/ContentContainer.js
function mapStateToProps2(state) {
  var props = {
    dispatch: state.dispatch
  };
  var api2 = new JsonApiDecorator2(state.api);
  if (api2.progress) {
    props.progress = api2.progress.first({
      content: ["content_config", "driver"]
    });
  }
  return props;
}
var DEFAULT_LOCALE = "en";
var ContentContainer = /*#__PURE__*/function (_Component8) {
  function ContentContainer(props) {
    var _this13;
    _classCallCheck(this, ContentContainer);
    _this13 = _callSuper(this, ContentContainer, [props]);
    _this13.isLeoContent = function (progress) {
      return !!(progress.content && progress.content.content_config && progress.content.content_config.driver.toLowerCase() === "leo");
    };
    // checks if the window has focus or if the active element is an iframe
    // in which we should still treat the window like it has focus
    _this13.windowHasFocus = function () {
      return (window.document.hasFocus ? window.document.hasFocus() : true) || (window.document.activeElement ? window.document.activeElement.tagName.toLowerCase() === "iframe" : false);
    };
    _this13.iframeHasFocus = function () {
      return window.document.activeElement ? window.document.activeElement.tagName.toLowerCase() === "iframe" : false;
    };
    _this13.handleWindowFocus = function () {
      _this13.setState({
        hasFocus: true
      });
    };
    _this13.handleWindowBlur = function () {
      _this13.setState({
        hasFocus: _this13.windowHasFocus()
      });
    };
    _this13.loadProgress = function (progressId) {
      return _this13.actions.loadProgress(progressId, _this13.props.contentServiceUrl, _this13.props.accessToken);
    };
    _this13.retryEvaluationWebhooks = function (progressId, responseSetId, evalufiUrl, token) {
      return _this13.actions.retryEvaluationWebhooks(progressId, responseSetId, evalufiUrl, token, _this13.props.contentServiceUrl, _this13.props.accessToken);
    };
    _this13.retakeEvaluation = function (slug) {
      return _this13.actions.retakeEvaluation(_this13.props.progress.id, slug, _this13.props.contentServiceUrl, _this13.props.accessToken);
    };
    _this13.fetchMissingResponseSet = function (slug) {
      return fetchMissingResponseSet(slug, _this13.props.progress.id, _this13.props.contentServiceUrl, _this13.props.accessToken);
    };
    _this13.logTime = function () {
      var _this13$state = _this13.state,
        hasFocus = _this13$state.hasFocus,
        contentId = _this13$state.contentId;
      var _this13$props = _this13.props,
        progress = _this13$props.progress,
        logTimeIntervalSeconds = _this13$props.logTimeIntervalSeconds;
      if (!hasFocus || !_this13.canLogTime()) {
        return;
      }
      if (++_this13.logTimeCount >= logTimeIntervalSeconds) {
        _this13.sendLogTime(contentId || progress.content.id, _this13.logTimeCount);
      }
    };
    _this13.canLogTime = function () {
      var contentId = _this13.state.contentId;
      var progress = _this13.props.progress;
      return progress && (progress.content.content_type !== "group" || contentId);
    };
    _this13.sendLogTime = function (contentId, logTime2) {
      var _this13$props2 = _this13.props,
        progress = _this13$props2.progress,
        contentServiceUrl = _this13$props2.contentServiceUrl,
        accessToken = _this13$props2.accessToken;
      _this13.actions.logTime(progress.id, contentId, logTime2, contentServiceUrl, accessToken);
      _this13.logTimeCount = 0;
    };
    _this13.startLogTimeInterval = function () {
      _this13.clearLogTimeInterval();
      _this13._log_time_interval = setInterval(_this13.logTime, 1e3);
    };
    _this13.clearLogTimeInterval = function () {
      clearInterval(_this13._log_time_interval);
      delete _this13._log_time_interval;
      var progress = _this13.props.progress;
      var contentId = _this13.state.contentId;
      if (!_this13.canLogTime()) {
        return;
      }
      _this13.sendLogTime(contentId || progress.content.id, _this13.logTimeCount);
    };
    _this13.verifyProgressComplete = function () {
      var completeAfterVerification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this13.setState({
        verifyingCompletion: true,
        completeAfterVerification: completeAfterVerification
      }, function () {
        _this13.actions.pollProgress(function () {
          return __async(_this13, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
            return _regeneratorRuntime().wrap(function _callee24$(_context24) {
              while (1) switch (_context24.prev = _context24.next) {
                case 0:
                  _context24.next = 2;
                  return this.loadProgress(this.props.progress.id);
                case 2:
                  return _context24.abrupt("return", _context24.sent);
                case 3:
                case "end":
                  return _context24.stop();
              }
            }, _callee24, this);
          }));
        }, _this13.shouldStopPolling, function () {
          _this13.pollingComplete(false);
        }, function () {
          _this13.pollingComplete(true);
        });
      });
    };
    _this13.shouldStopPolling = function () {
      if (_this13._destroyed) {
        return true;
      }
      var progress = _this13.props.progress;
      if (!progress) {
        return false;
      }
      return progress.preview || progress.status === "completed" || progress.policies_missing;
    };
    _this13.isProgressComplete = function () {
      var progress = _this13.props.progress;
      if (!progress) {
        return false;
      }
      return !progress.preview && progress.status === "completed";
    };
    _this13.onComplete = function () {
      return __async(_this13, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var isComplete;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              this.clearLogTimeInterval();
              this.setState({
                completeAfterVerification: true
              });
              if (this.state.verifyingCompletion) {
                _context25.next = 8;
                break;
              }
              isComplete = this.isProgressComplete();
              if (isComplete) {
                _context25.next = 7;
                break;
              }
              _context25.next = 7;
              return this.loadProgress(this.props.progress.id);
            case 7:
              this.executeComplete();
            case 8:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
    };
    _this13.onCannotVerifyCompletion = function () {
      _this13.setState({
        cannotVerifyCompletion: true
      });
    };
    _this13.pollingComplete = function (cannotVerifyCompletion) {
      _this13.setState({
        verifyingCompletion: false,
        cannotVerifyCompletion: cannotVerifyCompletion
      });
      _this13.onIntegratedContentComplete();
      if (_this13.state.completeAfterVerification) {
        _this13.executeComplete();
      }
    };
    _this13.executeComplete = function () {
      var isComplete = _this13.isProgressComplete();
      if (!isComplete && _this13.props.progress.policies_missing) {
        _this13.setState({
          signingPolicies: true
        });
        return;
      }
      _this13.onIntegratedContentComplete(true);
      if (_this13.props.onComplete) {
        _this13.props.onComplete(isComplete);
      }
    };
    _this13.sendIntegratedContentCompletePostMessage = function (closeAfterComplete) {
      if (_this13.isProgressComplete()) {
        _this13.sendPostMessage("integrated-content-complete");
      }
      if (closeAfterComplete) {
        setTimeout(function () {
          return _this13.sendPostMessage("integrated-content-close");
        });
      }
    };
    _this13.sendPostMessage = function (event_type) {
      parent.postMessage({
        event_type: event_type
      }, "*");
    };
    _this13.signPolicy = function (policyId, progressId) {
      var _this13$props3 = _this13.props,
        contentServiceUrl = _this13$props3.contentServiceUrl,
        jwt = _this13$props3.jwt;
      return _this13.actions.signPolicy(contentServiceUrl, jwt, policyId, progressId);
    };
    _this13.onSignPoliciesComplete = function () {
      _this13.setState({
        signingPolicies: false
      });
      _this13.verifyProgressComplete(true);
      if (_this13.props.router) {
        _this13.props.router.push("/");
      } else {
        window.location.href = "/".concat(_this13.props.organizationSlug, "/student/dashboard/#/");
      }
    };
    _this13.onIntegratedContentComplete = function (closeAfterComplete) {
      if (!_this13.props.isIntegratedContent) {
        return;
      }
      _this13.sendIntegratedContentCompletePostMessage(closeAfterComplete);
    };
    _this13.onContentChange = function (newContentId) {
      var progress = _this13.props.progress;
      var contentId = _this13.state.contentId;
      if (!progress || progress.content.content_type !== "group") {
        return;
      }
      if (contentId && contentId !== newContentId && _this13.logTimeCount > 0) {
        _this13.sendLogTime(contentId, _this13.logTimeCount);
      }
      _this13.setState({
        contentId: newContentId
      });
    };
    _this13.getMissingPolicies = function () {
      return _this13.props.progress.signed_business_policies.filter(function (policy) {
        return !(policy.signed_at || policy.obsolete_at);
      });
    };
    _this13.toggleLanguageModal = function () {
      _this13.setState({
        showLanguageModal: true
      });
    };
    _this13.isLanguageSet = function (code) {
      return window.location.href.indexOf("/".concat(code, "/")) !== -1;
    };
    _this13.getSupportedLanguages = function (progress, orgLanguages) {
      var languages = progress.content.languages;
      var contentLanguages = languages ? languages.map(function (code) {
        return code.replace("-", "_");
      }) : [];
      return Object.keys(orgLanguages).filter(function (key) {
        return contentLanguages.includes(key);
      }).reduce(function (language, key) {
        language[key] = orgLanguages[key];
        return language;
      }, {});
    };
    _this13.shouldShowLanguageSelector = function () {
      if (!_this13.props.showLanguageSelector || _this13.isLeoContent(_this13.props.progress)) {
        return false;
      }
      var supportedLanguages = _this13.getSupportedLanguages(_this13.props.progress, _this13.props.languageTranslationUrlConfig);
      var isLanguageSelected = _this13.props.locale !== DEFAULT_LOCALE || _this13.isLanguageSet(DEFAULT_LOCALE);
      return !isLanguageSelected && Object.keys(supportedLanguages).length > 1;
    };
    _this13.onConfirmLanguageSelection = function (code) {
      ReactifiStorage.setItem("selectedLanguageCode", code);
    };
    _this13.contentNameTitle = function (progress) {
      document.title = progress.content.name;
      return /* @__PURE__ */React18.createElement("div", {
        className: "sr-only",
        role: "alert"
      }, progress.content_name);
    };
    _this13.state = {
      completeAfterVerification: false,
      verifyingCompletion: false,
      cannotVerifyCompletion: false,
      hasFocus: _this13.windowHasFocus(),
      contentId: null,
      signingPolicies: false,
      polling: false,
      showLanguageModal: props.showLanguageSelector
    };
    _this13.actions = bindActionCreators(contentActionCreators_exports, _this13.props.dispatch);
    _this13.logTimeCount = 0;
    return _this13;
  }
  _inherits(ContentContainer, _Component8);
  return _createClass(ContentContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startLogTimeInterval();
      window.addEventListener("focus", this.handleWindowFocus);
      window.addEventListener("blur", this.handleWindowBlur);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearLogTimeInterval();
      window.removeEventListener("focus", this.handleWindowFocus);
      window.removeEventListener("blur", this.handleWindowBlur);
      this._destroyed = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.showLanguageSelector && !prevProps.progress && this.props.progress && !this.isLeoContent(this.props.progress)) {
        var supportedLanguages = this.getSupportedLanguages(this.props.progress, this.props.languageTranslationUrlConfig);
        var langCodes = Object.keys(supportedLanguages);
        if (langCodes.length === 1 && !this.isLanguageSet(langCodes[0])) {
          window.location.href = supportedLanguages[langCodes[0]].translation_url;
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_nextProps, nextState) {
      return nextState.hasFocus === this.state.hasFocus;
    }
  }, {
    key: "render",
    value: function render() {
      var progress = this.props.progress;
      var _this$state3 = this.state,
        cannotVerifyCompletion = _this$state3.cannotVerifyCompletion,
        completeAfterVerification = _this$state3.completeAfterVerification,
        verifyingCompletion = _this$state3.verifyingCompletion,
        signingPolicies = _this$state3.signingPolicies;
      if (cannotVerifyCompletion && completeAfterVerification) {
        return /* @__PURE__ */React18.createElement("div", {
          className: "foundry"
        }, /* @__PURE__ */React18.createElement("div", {
          className: "p-30 text-center f-20 foundry-red"
        }, /* @__PURE__ */React18.createElement(FAIcon2, {
          icon: "triangle-exclamation",
          additionalClasses: "m-r-5"
        }), t("There was an error saving your progress. Please contact your administrator.")));
      }
      if (!progress || completeAfterVerification && verifyingCompletion) {
        return /* @__PURE__ */React18.createElement("div", {
          className: "foundry"
        }, /* @__PURE__ */React18.createElement(ProgressSpinner3, null), /* @__PURE__ */React18.createElement("div", {
          className: "text-center m-10 f-18"
        }, completeAfterVerification ? t("Completing") : t("Loading"), "\u2026"));
      }
      if ((progress.content || {}).maintenance) {
        return /* @__PURE__ */React18.createElement(MaintenanceMode_default, {
          name: progress.content.name
        });
      }
      if (signingPolicies || progress.policies_missing) {
        return /* @__PURE__ */React18.createElement(SignPolicies_default, {
          policies: this.getMissingPolicies(),
          progressId: progress.id,
          signPolicy: this.signPolicy,
          onComplete: this.onSignPoliciesComplete,
          errorMessage: this.props.errorMessage
        });
      }
      if (this.state.responseSetsError) {
        return /* @__PURE__ */React18.createElement(ContentError_default, null, t("Something went wrong. Please try refreshing the page and if the problem persists contact our technical support."));
      }
      var Component9 = components_default[progress.content.content_type];
      var showLanguageSelector = this.shouldShowLanguageSelector();
      if (showLanguageSelector) {
        var body = document.querySelector("body");
        body.classList.add("foundry");
      }
      return /* @__PURE__ */React18.createElement(React18.Fragment, null, progress.content ? this.contentNameTitle(progress) : null, showLanguageSelector ? /* @__PURE__ */React18.createElement(LanguageModal, {
        showLanguageModal: this.state.showLanguageModal,
        toggleLanguageModal: this.toggleLanguageModal,
        languages: this.getSupportedLanguages(this.props.progress, this.props.languageTranslationUrlConfig),
        selectedLanguage: ReactifiStorage.getItem("selectedLanguageCode") || this.props.locale,
        enforceSelection: true,
        onConfirmSelection: this.onConfirmLanguageSelection
      }) : /* @__PURE__ */React18.createElement(Component9, __spreadProps(__spreadValues(__spreadValues({}, this.props), this.actions), {
        slug: progress.content.evalufi_slug,
        fetchMissingResponseSet: this.fetchMissingResponseSet,
        retryEvaluationWebhooks: this.retryEvaluationWebhooks,
        retakeEvaluation: this.retakeEvaluation,
        loadProgress: this.loadProgress,
        onComplete: this.onComplete,
        verifyProgressComplete: this.verifyProgressComplete,
        onCannotVerifyCompletion: this.onCannotVerifyCompletion,
        onIntegratedContentComplete: this.onIntegratedContentComplete,
        onContentChange: this.onContentChange
      })));
    }
  }]);
}(Component8);
ContentContainer.propTypes = {
  accessToken: PropTypes15.string,
  contentServiceUrl: PropTypes15.string,
  dispatch: PropTypes15.func.isRequired,
  errorMessage: PropTypes15.string,
  isIntegratedContent: PropTypes15.bool,
  jwt: PropTypes15.string,
  languageTranslationUrlConfig: PropTypes15.object,
  locale: PropTypes15.string,
  locales: PropTypes15.arrayOf(PropTypes15.string),
  logTimeIntervalSeconds: PropTypes15.number,
  onComplete: PropTypes15.func,
  organizationSlug: PropTypes15.string,
  progress: PropTypes15.shape({
    content: PropTypes15.shape({
      content_type: PropTypes15.string,
      evalufi_slug: PropTypes15.string,
      id: PropTypes15.string,
      maintenance: PropTypes15.bool,
      name: PropTypes15.string
    }),
    data: PropTypes15.shape({
      evaluations: PropTypes15.object
    }),
    id: PropTypes15.string,
    policies_missing: PropTypes15.bool,
    preview: PropTypes15.bool,
    signed_business_policies: PropTypes15.array,
    status: PropTypes15.string
  }),
  router: PropTypes15.shape({
    push: PropTypes15.func
  }),
  showLanguageSelector: PropTypes15.bool
};
ContentContainer.defaultProps = {
  logTimeIntervalSeconds: 10
};
var ContentContainer_default = connect2(mapStateToProps2)(ContentContainer);

// src/reducers/index.js
import { api } from "@everfi/reactifi/dist/es/reducers/ApiReducer";
import { routerReducer } from "react-router-redux";
var reducers_default = {
  api: api,
  routing: routerReducer
};

// src/store/contentStore.js
import { externalStoreSetup } from "@everfi/reactifi/dist/es/store";
var contentStore_default = function contentStore_default(props) {
  return externalStoreSetup(reducers_default, {}, props.endpointHost, props.endpointPath, props.accessToken);
};

// src/ContentApp.js
import { ChakraUIProvider } from "@everfi/reactifi";
var ContentApp = /*#__PURE__*/function (_React19$Component) {
  function ContentApp(props) {
    var _this14;
    _classCallCheck(this, ContentApp);
    _this14 = _callSuper(this, ContentApp, [props]);
    _this14.store = contentStore_default(props);
    return _this14;
  }
  _inherits(ContentApp, _React19$Component);
  return _createClass(ContentApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.store.dispatch(setHeader({
        "Accept-Language": this.props.locale
      }));
      this.store.dispatch(_loadProgress(this.props.progressId, this.props.endpointHost, this.props.accessToken));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
        endpointHost = _this$props11.endpointHost,
        endpointPath = _this$props11.endpointPath;
      var host = endpointHost[endpointHost.length - 1] !== "/" ? endpointHost + "/" : endpointHost;
      var path = endpointPath[0] === "/" ? endpointPath.substring(1, endpointPath.length) : endpointPath;
      path = path[path.length - 1] === "/" ? path.substring(0, path.length - 1) : path;
      return /* @__PURE__ */React19.createElement(Provider, {
        store: this.store
      }, /* @__PURE__ */React19.createElement(ChakraUIProvider, null, /* @__PURE__ */React19.createElement(ContentContainer_default, {
        progressId: this.props.progressId,
        accessToken: this.props.accessToken,
        jwt: this.props.jwt,
        portalEndpointUrl: this.props.portalEndpoint,
        portalHeartbeat: this.props.portalHeartbeat,
        contentServiceUrl: host,
        locale: this.props.locale,
        locales: this.props.locales,
        portalQueryString: this.props.portalQueryString,
        endpointUrl: "".concat(host).concat(path),
        host: host,
        organizationSlug: this.props.organizationSlug,
        onComplete: this.props.onComplete,
        onSafetyExit: this.props.onSafetyExit,
        primaryColor: this.props.primaryColor,
        router: this.props.router,
        secondaryColor: this.props.secondaryColor,
        iframed: this.props.iframed,
        isIntegratedContent: this.props.isIntegratedContent,
        logTimeIntervalSeconds: this.props.logTimeIntervalSeconds,
        showLanguageSelector: this.props.showLanguageSelector,
        languageTranslationUrlConfig: this.props.languageTranslationUrlConfig
      })));
    }
  }]);
}(React19.Component);
ContentApp.propTypes = {
  accessToken: PropTypes16.string.isRequired,
  endpointHost: PropTypes16.string.isRequired,
  endpointPath: PropTypes16.string.isRequired,
  iframed: PropTypes16.bool,
  isIntegratedContent: PropTypes16.bool,
  jwt: PropTypes16.string,
  languageTranslationUrlConfig: PropTypes16.object,
  locale: PropTypes16.string,
  locales: PropTypes16.arrayOf(PropTypes16.string),
  logTimeIntervalSeconds: PropTypes16.number,
  onComplete: PropTypes16.func,
  onSafetyExit: PropTypes16.func,
  organizationSlug: PropTypes16.string,
  portalEndpoint: PropTypes16.string,
  portalHeartbeat: PropTypes16.string,
  portalQueryString: PropTypes16.string,
  primaryColor: PropTypes16.string,
  progressId: PropTypes16.string,
  router: PropTypes16.shape({
    push: PropTypes16.func
  }),
  secondaryColor: PropTypes16.string,
  showLanguageSelector: PropTypes16.bool
};
ContentApp.displayName = "ContentApp";
export { ContentApp as default };